import apiConfig from '@constants/apiConfig';

import DeviceChildSavePage from './DeviceChildSavePage';
import OrderDisplayMappingListPage from './OrderDisplayMappingListPage';
import PickUpDeviceTabPage from './tabs';
import ListOrderDevicePage from '.';

export default {
    listOrderDevicePage: {
        path: '/order-device',
        title: 'Device Management',
        auth: true,
        component: ListOrderDevicePage,
        permission: [apiConfig.kitplayDevice.getList.baseURL],
    },
    listOrderDeviceTabPage: {
        path: '/order-device/:customerId/device-management/group-device',
        title: 'ReadyBoard mapping Management',
        auth: true,
        keyActiveTab: 'activeOrderDisplayDeviceTab',
        component: PickUpDeviceTabPage,
        permission: [apiConfig.orderDisplay.getList.baseURL],
    },
    listOrderDeviceChildSavePage: {
        path: '/order-device/:customerId/device-management/device-child/:id',
        title: 'ReadyBoard mapping Child Save Page',
        auth: true,
        component: DeviceChildSavePage,
        permission: [apiConfig.orderDisplay.create.baseURL, apiConfig.orderDisplay.update.baseURL],
    },
    orderDisplayMappingListPage: {
        path: '/order-device/:customerId/device-management/group-device/order-display-mapping',
        title: 'ReadyBoard Mapping',
        auth: true,
        component: OrderDisplayMappingListPage,
        permission: [apiConfig.orderDisplayMapping.getList.baseURL],
    },
};
